<template>
    <div class="m-t">
        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Usługa</label>
            <div class="col-sm-8">
                <select class="form-control" v-model="service">
                    <option value="inpost_courier_standard">Kurier InPost (standard)</option>
                    <option value="inpost_courier_express_1000">Kurier InPost (ekspres 10:00)</option>
                    <option value="inpost_courier_express_1200">Kurier InPost (ekspres 12:00)</option>
                    <option value="inpost_courier_saturday">Kurier InPost (sobota)</option>
                    <option value="inpost_locker_standard">Paczkomat (standard)</option>
                    <option value="inpost_locker_economy">Paczkomat (ekonomia)</option>
                </select>
            </div>
        </div>

        <div class="form-group row" v-if="isLocker">
            <label class="col-sm-3 form-control-label">Kod paczkomatu</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="targetPoint" placeholder="np. WAW01N">
            </div>
        </div>

        <hr>

        <strong>Zawartość przesyłki</strong>
        <div class="form-group row" v-for="(paczka, index) in parcels" :key="index">
            <label class="col-sm-2 form-control-label">#{{ index + 1 }}</label>
            <div class="col-sm-1 input-group">
                <input type="number" class="form-control" v-model.number="paczka.length" placeholder="Dł">
                <span class="input-group-addon text-sm p-a-xs">mm</span>
            </div>
            <div class="col-sm-1 input-group">
                <input type="number" class="form-control" v-model.number="paczka.width" placeholder="Szer">
                <span class="input-group-addon text-sm p-a-xs">mm</span>
            </div>
            <div class="col-sm-1 input-group">
                <input type="number" class="form-control" v-model.number="paczka.height" placeholder="Wys">
                <span class="input-group-addon text-sm p-a-xs">mm</span>
            </div>
            <div class="col-sm-2 input-group">
                <input type="number" class="form-control" v-model.number="paczka.weight" placeholder="Waga" step="0.1">
                <span class="input-group-addon text-sm p-a-xs">kg</span>
            </div>
            <div class="col-sm-3 input-group">
                <input type="text" class="form-control" v-model="paczka.reference" placeholder="Opis">
                <span class="input-group-addon">opis</span>
            </div>
            <div class="col-sm-1">
                <button type="button" class="btn white" tabindex="-1" @click="parcels.splice(index, 1)">Usuń</button>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-2 form-control-label">Dodaj paczkę</label>
            <div class="col-sm-2">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addParcel(200,200,200,1)">+ A (mała)</button>
            </div>
            <div class="col-sm-2">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addParcel(300,300,300,3)">+ B (średnia)</button>
            </div>
            <div class="col-sm-2">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addParcel(600,500,300,15)">+ C (duża)</button>
            </div>
        </div>

        <hr>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Zawartość</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="content" placeholder="Zawartość">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Numer referencyjny</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="reference" placeholder="Numer referencyjny">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Kwota ubezpieczenia</label>
            <div class="col-sm-8 input-group">
                <input type="text" class="form-control" v-model="insurance" placeholder="0.00">
                <span class="input-group-addon">PLN</span>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Opcje dodatkowe</label>
            <div class="col-sm-8">
                <p>
                    <label class="md-check">
                        <input v-model="isCod" type="checkbox">
                        <i class="blue"/> Za pobraniem
                    </label>
                </p>
            </div>
            <Spinner v-if="isProcessing"/>
        </div>

        <div class="form-group row" v-if="isCod">
            <label class="col-sm-3 form-control-label">Kwota pobrania</label>
            <div class="col-sm-8 input-group">
                <input type="text" class="form-control" v-model="codAmount" @change="parsePrice" placeholder="0.00">
                <span class="input-group-addon">PLN</span>
            </div>
        </div>

        <a href="#" class="btn info none-radius m-t" @click.prevent="save" :class="{disabled: isProcessing}">Zapisz</a>
    </div>
</template>

<script>
import Spinner from '../../Spinner.vue';
import Api from '../../../Api.js';

export default {
    name: 'CarrierInpost',
    props: {
        order: Object,
        sender: Object,
        recipient: Object,
        selectedBoxAndPallets: Array
    },
    components: { Spinner },
    data() {
        return {
            isProcessing: false,
            service: 'inpost_courier_standard',
            targetPoint: '',
            parcels: [],
            content: 'Filtry powietrza',
            reference: '',
            insurance: '',
            isCod: false,
            codAmount: ''
        };
    },
    computed: {
        isLocker() {
            return this.service.includes('locker');
        }
    },
    created() {
        this.reference = this.order.invoiceNo || '';

        if (this.order.clientNo && this.order.clientNo.length > 0) {
            this.content = 'Filtry powietrza - numer zamówienia ' + this.order.clientNo;
        }

        if (this.order.deliveryIsCod) this.isCod = true;

        if (this.order.customer && this.order.customer.pickupPoints && this.order.customer.pickupPoints.inpost) {
            this.targetPoint = this.order.customer.pickupPoints.inpost;
            this.service = 'inpost_locker_standard';
        }

        if (this.selectedBoxAndPallets && this.selectedBoxAndPallets.length > 0) {
            this.setBoxesFromOrder();
        } else {
            this.parcels.push({ length: 200, width: 200, height: 200, weight: 1, reference: 'Karton #1' });
        }
    },
    methods: {
        addParcel(length, width, height, weight) {
            this.parcels.push({
                length,
                width,
                height,
                weight,
                reference: 'Karton #' + (this.parcels.length + 1)
            });
        },

        parsePrice() {
            this.codAmount = this.codAmount.replace(/,/g, '.');
        },

        setBoxesFromOrder() {
            if (this.order.shippingPalletes) {
                for (let i = 0; i < this.order.shippingPalletes.length; i++) {
                    const box = this.order.shippingPalletes[i];
                    if (!this.selectedBoxAndPallets.find(s => s == box._id)) continue;
                    this.parcels.push({
                        length: box.length,
                        width: box.width,
                        height: box.height,
                        weight: box.mass,
                        reference: '#' + (i + 1) + ' ' + (box.code ? box.code.toUpperCase() : 'PALETA')
                    });
                }
            }
            if (this.parcels.length > 0) return;
            for (let i = 0; i < this.order.boxes.length; i++) {
                const box = this.order.boxes[i];
                if (!this.selectedBoxAndPallets.find(s => s == box._id)) continue;
                this.parcels.push({
                    length: box.length,
                    width: box.width,
                    height: box.height,
                    weight: box.mass,
                    reference: '#' + (i + 1) + ' ' + box.code.toUpperCase()
                });
            }
        },

        buildPackage() {
            const pkg = {
                service: this.service,
                receiver: this.buildReceiver(),
                sender: this.buildSender(),
                parcels: this.parcels.map((p, i) => ({
                    id: String(i + 1),
                    dimensions: { length: p.length, width: p.width, height: p.height },
                    weight: { amount: p.weight },
                    reference: p.reference
                })),
                reference: this.reference,
                custom_attributes: {}
            };

            if (this.content) {
                pkg.comments = this.content;
            }
            if (this.isLocker && this.targetPoint) {
                pkg.custom_attributes.target_point = this.targetPoint.toUpperCase();
            }
            if (this.insurance) {
                pkg.insurance = { amount: parseFloat(this.insurance), currency: 'PLN' };
            }
            if (this.isCod && this.codAmount) {
                pkg.cod = { amount: parseFloat(this.codAmount), currency: 'PLN' };
            }

            return pkg;
        },

        buildSender() {
            return {
                name: this.sender.firstname + ' ' + this.sender.lastname,
                company_name: this.sender.company_name,
                email: this.sender.email || '',
                phone: this.sender.phone || '',
                address: {
                    line1: this.sender.street,
                    city: this.sender.city,
                    post_code: this.sender.postcode,
                    country_code: this.sender.countryCode || 'PL'
                }
            };
        },

        buildReceiver() {
            return {
                name: this.recipient.contactPerson || this.recipient.name,
                company_name: this.recipient.name,
                email: this.recipient.email || '',
                phone: this.recipient.phone || '',
                address: {
                    line1: this.recipient.street,
                    city: this.recipient.city,
                    post_code: this.recipient.postCode,
                    country_code: this.recipient.countryCode || 'PL'
                }
            };
        },

        async save() {
            this.isProcessing = true;
            try {
                const shipment = await Api.shipments.inpost.send({
                    order: this.order._id,
                    package: this.buildPackage()
                });
                this.$emit('shipments', Array.isArray(shipment) ? shipment : [shipment]);
                this.$h.success('Dodano przesyłkę InPost');
            } catch (e) {
                this.$h.commonApiError(e, true);
            }
            this.isProcessing = false;
        }
    }
};
</script>
